import React from 'react'
import { useDispatch } from 'react-redux'
import { actions } from 'src/features/receivement/ReceivementState'
import ModalObservation from '../../components/ModalObservation'

const MAX_LENGTH = 400

interface Props {
  id?: number;
  productObservation?: string;
  wrongProduct?: boolean;
}

export const useObservationModal = ({ id, productObservation, wrongProduct }: Props) => {
  const [show, setShow] = React.useState(false)
  const dispatch = useDispatch()

  const openObservationModal = React.useCallback(() => {
    dispatch(actions.setObservation(productObservation || ''))
    setShow(true)
  }, [dispatch, productObservation])

  const closeObservationModal = React.useCallback(() => {
    dispatch(actions.setObservation(''))
    setShow(false)
  }, [dispatch])

  const ObservationModalComponent = (
    show && (
    <ModalObservation
      id={id}
      show={show}
      maxLength={MAX_LENGTH}
      wrongProduct={wrongProduct}
      closeObservationModal={closeObservationModal}
    />
    )
  )

  return {
    openObservationModal,
    ObservationModalComponent,
  }
}
